/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';

import {
  buildCreateTripAnalytics,
  buildDateSelectionAnalytics,
  buildStationSelectionAnalytics,
  buildClickSearchAnalytics,
  buildFlightSearchClickAnalytics,
  buildSearchWidgetViewedAnalytics,
} from './flightSearch.analytics';
import {
  FlightSearchClickParams,
  FlightSearchParams,
} from './flightSearch.meta';

import { resolveAnalyticsParams } from '../../util/utils';

const platform = Platform.OS;

export const createTripEvent = (params: FlightSearchParams) => {
  return resolveAnalyticsParams(buildCreateTripAnalytics(params), platform);
};

export const dateSelectionEvent = (params: FlightSearchParams) => {
  return resolveAnalyticsParams(buildDateSelectionAnalytics(params), platform);
};

export const stationSelectionEvent = (params: FlightSearchParams) => {
  return resolveAnalyticsParams(
    buildStationSelectionAnalytics(params),
    platform,
  );
};

export const searchEvent = (params: FlightSearchParams) => {
  return resolveAnalyticsParams(buildClickSearchAnalytics(params), platform);
};

export const flightSearchClickEvent = (params: FlightSearchClickParams) => {
  return resolveAnalyticsParams(
    buildFlightSearchClickAnalytics(params),
    platform,
  );
};

export const searchWidgetViewedEvent = () => {
  return resolveAnalyticsParams(buildSearchWidgetViewedAnalytics(), platform);
};
